"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStaticListSource = exports.useListSource = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
const fetch_hook_1 = require("./fetch-hook");
const event_callback_hook_1 = require("./event-callback-hook");
const crud_source_hook_1 = require("./crud-source-hook");
function useListSource({ url, apiUrl, params, method = 'POST', skip = false, }) {
    const [result, loading, reset] = fetch_hook_1.useFetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: params !== undefined ? JSON.stringify(params) : undefined,
        skip,
    });
    const loadDetail = event_callback_hook_1.useEventCallback(async (item) => {
        if (apiUrl !== undefined) {
            const fetch = crud_source_hook_1.defaultGetItem(apiUrl, item.id);
            const detail = await fetch.json();
            return detail;
        }
        return Promise.resolve(item);
    });
    const source = react_1.useMemo(() => ({
        items: result !== null && result !== void 0 ? result : [],
        loading,
        reset,
        loadDetail,
    }), [loading, reset, result, loadDetail]);
    return source;
}
exports.useListSource = useListSource;
function useStaticListSource(items) {
    return {
        loading: false,
        reset: lodash_1.noop,
        loadDetail: identityPromise,
        items,
    };
}
exports.useStaticListSource = useStaticListSource;
function identityPromise(item) {
    return Promise.resolve(item);
}
//# sourceMappingURL=list-source-hook.js.map